import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { WebComponentsConfigService } from '../../services/config/config.service';
import { ValueOf } from '../../types/base/';
import { ApplicationIcon, FileIcon, Icon } from '../../types/icon-list.type';

export const iconSizeOptions = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  LOGO: 'logo',
  IMAGOTYPE: 'imagotype',
  /** default value */
  FREE: 'free',
} as const;
export type IconSizeOption = ValueOf<typeof iconSizeOptions>;

export type IconType = {
  icon?: Icon;
  app?: ApplicationIcon;
  file?: FileIcon;
  svgPath?: string;
  imgUrl?: string;
  alt?: string;
  showBadge?: boolean;
  size?: IconSizeOption;
};
@Component({
  selector: 'evc-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  readonly #config = inject(WebComponentsConfigService);

  icon = input<Icon>();
  app = input<ApplicationIcon>();
  file = input<FileIcon>();
  svgPath = input<string>();
  imgUrl = input<string>();
  alt = input<string>();
  size = input<IconSizeOption>(iconSizeOptions.FREE);

  /** you may define it via the config service. @see storybook Settings/Config */
  readonly basePath = input(this.#config.getComputed('ASSETS_BASE_PATH'));
}
